
<template>

  <tbody>

    <tr :class="{ active: quarter.status === 'reserved',
                  disabled: quarter.status === 'taken' || quarter.status === 'read' }">

      <td rowspan="2" class="center aligned">{{ quarter.part }}</td>
      <td rowspan="2">{{ quarter.name }}</td>

      <td>{{ quarter.from }}</td>

      <td rowspan="2" class="center aligned">{{ quarter.pages }}</td>

    </tr>

    <tr :class="{ active: quarter.status === 'reserved',
                  disabled: quarter.status === 'taken' || quarter.status === 'read' }">
      <td class="to">{{ quarter.to }}</td>
    </tr>

  </tbody>

</template>

<script>
export default {

  name: 'QuarterRow',
  props: {

    quarter: Object,

  }

}
</script>

<style scoped>
* {
  direction: rtl;
  text-align: right;
}

.disabled * {
  color: rgba(40, 40, 40, 0.15) !important;
}

.to {
  border-top: 1px solid rgba(34, 36, 38, 0.05) !important;
}
</style>
